import { useMemo } from "react";
import { UrlReport } from "../@types";

interface UseStartAutoAnalyzeParams {
  urlReport: UrlReport | undefined;
}

const useCheckForAutoUrlAnalysis = ({
  urlReport
}: UseStartAutoAnalyzeParams) => {
  const shouldStartAutoAnalysis = useMemo(() => {
    if (urlReport === undefined) return false;
    return (urlReport?.analysis?.analysis_history?.length || 0) === 0;
  }, [urlReport]);

  return { shouldStartAutoAnalysis };
};

export default useCheckForAutoUrlAnalysis;
